<template>
  <v-app id="app_measurements">
    <v-overlay
      v-model="centerLoading"
      class="custom_centered_overlay"
    >
      <v-progress-circular
        color="#2A8200"
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

    <v-container fluid>
      <v-row>
        <v-col class="mt-0" cols="7">
          <p class="custom_page_main_title">DAY IN REJECTED LIST</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">
            Used to manage day in approved requests.
          </p>
        </v-col>
        <v-col class="px-4 mt-7" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-divider
              :thickness="3"
              class="divider-vertical"
              vertical
            ></v-divider>
            <v-btn
              class="gray-text"
              size="x-large"
              variant="text"
              @click="backPageRoute"
            >
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="pa-5 mt-5">
        <v-row justify="end">
          <v-col cols="auto">
            <v-btn
              class="custom_excel_btn"
              variant="outlined"
              @click="exportExcelDayInApprovalRequestList"
            >
              <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
            </v-btn>
          </v-col>
        </v-row>
        <v-divider class="mt-2 mb-4"></v-divider>

        <v-row>
          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="selectedOfficerTitle"
              :items="officerTitleList"
              clearable
              item-title="role_type"
              item-value="id"
              label="Officer Category"
              multiple
              placeholder="Select Officer Category"
              variant="outlined"
              density="comfortable"
              class="custom_input_field_color"
            />
          </v-col>

          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="selectedOfficer"
              :items="officersListBasedOnRole"
              clearable
              item-title="name"
              item-value="id"
              label="Officer"
              multiple
              placeholder="Select Officer Name"
              variant="outlined"
              density="comfortable"
              class="custom_input_field_color"
            />
          </v-col>

          <v-col cols="12" md="4">
            <v-date-input
              v-model="dates"
              label="Select Date Range"
              prepend-icon=""
              prepend-inner-icon="$calendar"
              multiple="range"
              variant="outlined"
              clearable
              @update:model-value="onDateRangeSelected"
              @click:clear="clearDateRange"
              density="comfortable"
            />
          </v-col>
        </v-row>

        <v-row
          class="pa-2 mb-4"
          style="
            background-color: #fff3cd;
            border: 1px solid #566573;
            border-radius: 4px;
          "
        >
          <v-col class="d-flex align-center" cols="12">
            <v-icon color="success" size="small" class="mr-1"
              >mdi-checkbox-blank-circle</v-icon
            >
            <span class="mr-4" style="font-size: 12px; color: #333"
              >ON TIME</span
            >

            <v-icon color="error" size="small" class="mr-1"
              >mdi-checkbox-blank-circle</v-icon
            >
            <span style="font-size: 12px; color: #333">LATE</span>
          </v-col>
        </v-row>

        <v-data-table
          class="mt-4"
          :group-by="groupBy"
          :headers="headers"
          :items="apiData"
          item-value="user_id"
          :loading="loading"
        >
          <template
            v-slot:group-header="{ item, columns, toggleGroup, isGroupOpen }"
          >
            <tr>
              <td :colspan="columns.length">
                <v-btn
                  :icon="
                    isGroupOpen(item) ? 'mdi-chevron-down' : 'mdi-chevron-right'
                  "
                  size="small"
                  variant="text"
                  @click="toggleGroup(item)"
                />
                <span class="text-muted">
                  {{item.value.split(' - ')[0]}}
                </span>
                <br />
                <span class="blue--text font-weight-bold ml-10"
                  >Reg num: {{item.value.split(' - ')[1] }}</span
                >
              </td>
            </tr>
          </template>

          <template v-slot:[`item.day_in_time`]="{ item }">
            <div class="d-flex align-center">
              <v-icon
                v-if="item.status =='On-Time'"
                color="success"
                size="small"
                class="mr-1"
              >
                mdi-checkbox-blank-circle
              </v-icon>
              <v-icon
                v-else
                color="error"
                size="small"
                class="mr-1"
              >
                mdi-checkbox-blank-circle
              </v-icon>
              <div>
                <span>{{ formatTime(item.day_in_time) }}</span> <br />
                <span
                  v-if="item.day_in_location"
                  class="blue--text font-weight-bold"
                  >{{ item.day_in_location }}</span
                >
                <span v-else class="blue--text font-weight-bold"
                  >No location</span
                >
              </div>
            </div>
          </template>

          <template v-slot:[`item.approved_day_in_at`]="{ item }">
            <div>
              <span>{{ formatDateTime(item.approved_day_in_at) }}</span>
            </div>
          </template>

          <template v-slot:[`item.day_in_date`]="{ item }">
            <div>
              <span>{{ formatDate(item.day_in_date) }}</span>
            </div>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-btn
              style="
                width: 90% !important;
                background-color: #e6effc !important;
                border: 1px solid #0000ff !important;
                color: #0000ff !important;
              "
              variant="outlined"
              @click="openActionDialog(item)"
            >
              REASON
            </v-btn>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog
          v-model="dayInApprovedRequestDialog"
          max-height="700"
          id="app_lead_list"
          max-width="600"
        >
          <v-card rounded="md">
            <div class="pa-4">
              <v-card color="#F0F0F0" flat>
                <template v-slot:prepend>
                  <v-card-title class="text-subtitle-1 font-weight-bold">
                    REJECTED DAY IN REQUEST
                  </v-card-title>
                </template>
                <v-spacer></v-spacer>
                <template v-slot:append>
                  <v-btn
                    @click="dayInApprovedRequestDialog = false"
                    icon="mdi-close"
                    size="x-small"
                  ></v-btn>
                </template>
              </v-card>

              <!-- Form Content -->
              <v-card-text>
                <v-form ref="form">
                  <v-text-field
                    v-model="selectedItem.user.name"
                    label="Officer name"
                    placeholder="Officer name"
                    variant="outlined"
                    required
                    readonly
                  ></v-text-field>

                  <v-text-field
                    v-model="selectedItem.day_in_date"
                    label="Date"
                    placeholder="Date"
                    variant="outlined"
                    required
                    readonly
                  ></v-text-field>

                  <v-textarea
                    v-model="selectedItem.reason"
                    label="Message"
                    placeholder="Enter your message"
                    readonly
                  ></v-textarea>
                </v-form>
              </v-card-text>
            </div>
          </v-card>
        </v-dialog>

      <v-snackbar v-model="snackbar" :color="snackbarColor" location="top-right" outlined timeout="3000">
          {{snackbarMessage}}
          <template v-slot:action="{ attrs }">
            <v-btn icon v-bind="attrs" @click="snackbar = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import * as XLSX from 'xlsx';

export default {
  data() {
    return {
      centerLoading: false,
      loading: false,
      userCategory: [],
      officerNames: [],
      snackbar: false,
      snackbarColor:"",
      snackbarMessage:"",
      rejectReason:"",
      userCategoryItems: [{ name: "Category A" }, { name: "Category B" }],
      officerItems: [],
      selectedItem: {
        user: {
          name: "",
        },
        day_in_date: "",
      },
      dayInApprovedRequestDialog:false,
      groupBy: [{ key: "group_by_user", order: "asc" }],
      headers: [
        // {
        //   title: "OFFICER NAME",
        //   align: "start",
        //   sortable: false,
        //   key: "user.name",
        // },
        { title: "DAY IN", key: "day_in_time" },
        { title: "DAY IN DATE", key: "day_in_date" },
        { title: "REJECTED DATE", key: "rejected_day_in_at" },
        { title: "ACTION", key: "action" },
      ],
      tableData: [],
      apiData: [],
      officerTitleList:[],
      officersListBasedOnRole:[],
      selectedOfficerTitle:null,
      selectedOfficer:null,

      startDate:null,
      endDate:null,

      dates:null,
    };
  },
  computed: {
    
  },
  created() {
    this.getOfficerTitles();
    this.fetchData();
  },
  watch: {
    selectedOfficerTitle(newVal) {
      this.selectedOfficer = null;
      this.getUserListBasedOnRoles(newVal); // This triggers on every checkbox change
    },

    selectedOfficer(newVal){
      this.selectedOfficer = newVal;
      this.fetchData();
    }
  },
  methods: {
    async fetchData() {
      this.centerLoading = true;
      this.loading = true;
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}api/am/web/day-in-request-rejected/get`, {startDate:this.startDate, endDate:this.endDate, selectedOfficers: this.selectedOfficer}
        );

        if (response.data.success) {
          this.apiData = response.data.data;
          // this.tableData = this.processData(response.data.data);
          // this.prepareOfficerItems();
        } else {
          console.error(
            "API request was not successful:",
            response.data.message
          );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.centerLoading = false;
        this.loading = false;
      }
    },

        getOfficerTitles() {
            this.centerLoading = true;
            // const userId = localStorage.getItem('userId');
            const token = localStorage.getItem('token');

            axios.post(`${process.env.VUE_APP_API_BASE_URL}api/um/web/get-mobile-user-roles`, {}, {
                headers: {
                Authorization: `Bearer ${token}`, // Include the Authorization header with the Bearer token
                }
            })
                .then(response => {
                    this.officerTitleList = response.data.data;
                    
                    this.centerLoading = false;
                    console.log('Error fetching dashboard permissions:', response);
                })
                .catch(error => {
                    this.centerLoading = false;
                    console.error('Error fetching dashboard permissions:', error);
                });
            },

            getUserListBasedOnRoles(selectedRoles){
                this.centerLoading = true;
            // const userId = localStorage.getItem('userId');
            const token = localStorage.getItem('token');

            axios.post(`${process.env.VUE_APP_API_BASE_URL}api/um/web/get-mobile-users-based-on-roles`, {userRoleId:selectedRoles}, {
                headers: {
                Authorization: `Bearer ${token}`, // Include the Authorization header with the Bearer token
                }
            })
                .then(response => {
                    this.officersListBasedOnRole = response.data.data;
                    
                    this.centerLoading = false;
                    
                })
                .catch(error => {
                    this.centerLoading = false;
                    console.error('Error fetching ', error);
                });
            },

            onDateRangeSelected(newDates){
                if(newDates){
                this.dates = newDates;
                
                this.startDate = new Date(this.dates[0]);
                this.startDate.setDate(this.startDate.getDate() + 1);
                this.startDate = this.startDate.toISOString().split('T')[0];
                this.endDate = this.dates.length > 1 ? new Date(this.dates[this.dates.length - 1]).toISOString().split('T')[0] : this.startDate;

                this.fetchData();

                console.log("Date",this.startDate, this.endDate);
                }else{
                    this.dates = null;
                    this.startDate = null;
                    this.endDate =  null;
                    this.fetchData();
                }
            },

            exportExcelDayInApprovalRequestList() {
              let tableData = [];
        if(this.apiData.length > 0){
                tableData = this.apiData.map((item, index) => ({
                '#': index + 1,
                'Officer Name': item.user.name,
                'User Reg Number': item.user.registration_num,
                'Day In Date': item.day_in_date,
                'Day In Time': item.day_in_time,
                'Day In Location': item.day_in_location,
                'Status': item.status,
                'Rejected Reason': item.reason,
                'Rejected Date': item.rejected_day_in_at,
                }));
        }else{
          tableData = [{
          '#': "",
          'Officer Name': "",
          'User Reg Number': "",
          'Day In Date': "",
          'Day In Time': "",
          'Day In Location': "",
          'Status': "",
          'Rejected Reason': "",
          'Rejected Date': "",
        }];
        }

                const worksheet = XLSX.utils.json_to_sheet(tableData);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Day In Rejected Request List');
                XLSX.writeFile(workbook, 'Day_in_rejected_request_List.xlsx');

                const fileName = 'Day_in_rejected_request_List.xlsx';
                const file_type = 'excel';
                this.logDocumentDownload(fileName,file_type, "Day In Rejected Officers List");
            },

            openActionDialog(item) {
              this.selectedItem = JSON.parse(JSON.stringify(item));
              this.dayInApprovedRequestDialog = true;
            },

            async logDocumentDownload(fileName,file_type, entityArea) {
                    console.log(fileName);
                    try {
                    const token = localStorage.getItem('token');
                    const userId = localStorage.getItem('userId');

                    if (!userId) {
                        throw new Error('User ID not found');
                    }

                    // Asynchronous API call to log download
                    const response = await axios.post(`/api/log-document-download`, {
                        user_id: userId,
                        file_type: file_type,
                        file_name: fileName,
                        entity_area: entityArea,

                        headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                        }
                    });

                    if (response.status !== 200) {
                        throw new Error('Failed to log download');
                    }

                    console.log('Download logged successfully');
                    } catch (error) {
                    console.error('Error logging download:', error);
                    }
                },

    processData(data) {
      return data.map((item) => {
        return {
          ...item,
          officerName: item.user
            ? item.user.name
            : `Unknown User (ID: ${item.user_id})`,
        };
      });
    },

    prepareOfficerItems() {
      const uniqueUsers = {};
      this.apiData.forEach((item) => {
        if (item.user && !uniqueUsers[item.user.id]) {
          uniqueUsers[item.user.id] = {
            id: item.user.id,
            name: item.user.name,
          };
        }
      });
      this.officerItems = Object.values(uniqueUsers);
    },

    getUserName(userId) {
      const user = this.apiData.find((item) => item.user_id === userId)?.user;
      return user ? user.name : `Unknown User (ID: ${userId})`;
    },

    formatTime(timeString) {
      if (!timeString) return "No time";
      const [hours, minutes] = timeString.split(":");
      const hour = parseInt(hours, 10);
      const ampm = hour >= 12 ? "PM" : "AM";
      const hour12 = hour % 12 || 12;
      return `${hour12}:${minutes} ${ampm}`;
    },

    formatDate(dateString) {
      if (!dateString) return "No date";
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(dateString).toLocaleDateString(undefined, options);
    },

    formatDateTime(dateTimeString) {
      if (!dateTimeString) return "Not approved";
      const date = new Date(dateTimeString);
      const options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      return date.toLocaleDateString(undefined, options);
    },

    isOnTime(timeString) {
      if (!timeString) return false;
      const [hours, minutes] = timeString.split(":").map(Number);
      // Consider on time if before 8:30 AM
      return hours < 8 || (hours === 8 && minutes <= 30);
    },

    backPageRoute() {
      this.$router.go(-1);
    },

    exportExcel() {
      console.log("Export Excel clicked");
      // Implement Excel export functionality here
    },
  },
};
</script>

<style scoped>
.blue--text {
  color: blue;
}
.custom_centered_overlay {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>